import { render, staticRenderFns } from "./ClueActionManage.vue?vue&type=template&id=06cbef2e&"
import script from "./ClueActionManage.vue?vue&type=script&lang=js&"
export * from "./ClueActionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports